import { useState } from 'react'
import { Outlet, useMatch } from 'react-router-dom'
import { motion } from 'framer-motion'
import { StoreHeader } from './StoreHeader'
import { StoreFooter } from './StoreFooter'
import { StoreFloatingActions } from './WhatsAppButton'
import { WelcomeOnboardingModal } from '@/store/components/WelcomeOnboardingModal'
import { ProductRequestModal } from '@/store/components/ProductRequestModal'
import { RaiseBugModal } from '@/store/components/RaiseBugModal'
import { useStoreGate } from '@/contexts/StoreGateContext'

export function StoreLayout() {
  const { settings } = useStoreGate()
  const [productRequestOpen, setProductRequestOpen] = useState(false)
  const [raiseBugOpen, setRaiseBugOpen] = useState(false)
  const isProductDetail = Boolean(useMatch('/shop/:id'))

  return (
    <div className="flex min-h-screen flex-col">
      <StoreHeader />
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="flex-1"
      >
        <Outlet context={{ settings }} />
      </motion.main>
      <StoreFooter
        instagram={settings?.instagram}
        email={settings?.email}
        phone={settings?.phone}
        whatsapp={settings?.whatsapp}
        onRequestProduct={() => setProductRequestOpen(true)}
        onRaiseBug={() => setRaiseBugOpen(true)}
        productRequestActive={productRequestOpen}
        raiseBugActive={raiseBugOpen}
      />
      {isProductDetail && (
        <div aria-hidden className="product-mobile-bar-spacer lg:hidden" />
      )}
      <StoreFloatingActions phone={settings?.whatsapp} />
      <WelcomeOnboardingModal />
      <ProductRequestModal
        open={productRequestOpen}
        onClose={() => setProductRequestOpen(false)}
      />
      <RaiseBugModal
        open={raiseBugOpen}
        onClose={() => setRaiseBugOpen(false)}
      />
    </div>
  )
}
